// @ts-check
export const DEFAULT_LANGUAGE = Object.freeze(/** @type {const} */ ({
  Name: 'Español',
  Code: 'es-ES',
}));

export const LANGUAGES = /** @type {const} */ ([
  { Name: 'Español', Code: 'es-ES' },
  { Name: 'Français', Code: 'fr-FR' },
  { Name: 'English', Code: 'en-GB' },
]);

export const ModuleProcessMappings = Object.freeze(/** @type {const} */ ({
  ProductionControl: {
    Id: 7529,
    Name: 'Control de Producción',
    Processes: {
      Locations: {
        Id: 6622,
        Name: 'Ubicaciones',
      },
      Dumping: {
        Id: 6624,
        Name: 'Volcado',
      },
      ManageProductionLines: {
        Id: 6625,
        Name: 'Gestionar líneas de producción',
      },
      ProductionPlanner: {
        Id: 10824,
        Name: 'Planificador de producción',
      },
      ProductionPlanningStatus: {
        Id: 6627,
        Name: 'Estado de pedidos en producción',
      },
      KiloRecord: {
        Id: 7634,
        Name: 'Registro de Kilos',
      },
      ManageProductionOutputs: {
        Id: 9671,
        Name: 'Gestionar Salidas de Producción',
      },
    },
    Submodules: {
      Palletized: {
        Id: 7540,
        Name: 'Paletizado',
        Processes: {
          MultiplePalletized: {
            Id: 6626,
            Name: 'Paletizado múltiple',
          },
          Palletized: {
            Id: 7633,
            Name: 'Paletizado',
          },
          Picking: {
            Id: 7636,
            Name: 'Picking',
          },
        },
      },
      IndividualProduction: {
        Id: 9586,
        Name: 'Producción Individual',
        Processes: {
          CountBoxPerWorker: {
            Id: 9724,
            Name: 'Recuento de cajas por trabajador',
          },
          BoxReadings: {
            Id: 9728,
            Name: 'Registro de cajas',
          },
        },
      },
    },
  },

  PresenceControl: {
    Id: 7541,
    Name: 'Control de Presencia',
    Submodules: {
      AttendanceManagement: {
        Name: 'Gestión de marcajes',
        Processes: {
          AttendanceQuery: {
            Id: 6601,
            Name: 'Consulta marcajes',
          },
          MassiveAttendanceRecords: {
            Id: 6619,
            Name: 'Marcajes masivos',
          },
        },
      },
    },
  },

  ActivityControl: {
    Id: 7546,
    Name: 'Control de Actividades',
    Processes: {
      DeviceActivity: {
        Id: 6618,
        Name: 'Actividades dispositivos',
      },
      WorkersActivity: {
        Id: 6620,
        Name: 'Actividades trabajadores',
      },
      ProductiveActivityLine: {
        Id: 6621,
        Name: 'Actividades productivas en línea',
      },
    },
  },

  Commercialisation: {
    Id: 7548,
    Name: 'Comercializadora',
    Processes: {
      Expeditions: {
        Id: 6623,
        Name: 'Expediciones',
      },
      PurchaseContracts: {
        Id: 9667,
        Name: 'Contratos de compra',
      },
      SalesOrders: {
        Id: 9668,
        Name: 'Pedidos de venta',
      },
      ReturnablesManagement: {
        Id: 10900,
        Name: 'Gestion de retornables',
      },
    },
  },

  Repairs: {
    Id: 8551,
    Name: 'Reparaciones',
    Processes: {
      RepairParts: {
        Id: 9749,
        Name: 'Partes de Reparación',
      },
      RepairInterventions: {
        Id: 7637,
        Name: 'Intervenciones en Partes de Reparación',
      },
    },
  },

  Reports: {
    Id: 9570,
    Name: 'Informes',
    Processes: {},
  },

  Warehouse: {
    Id: 9576,
    Name: 'Almacén',
    Processes: {
      ManageShoppingLocation: {
        Id: 9687,
        Name: 'Gestionar ubicación compras',
      },
      ManageSalesLocation: {
        Id: 9688,
        Name: 'Gestionar ubicación ventas',
      },
      InventoryRegularization: {
        Id: 9689,
        Name: 'Recuento y regularización de inventario',
      },
    },
  },

  Alhondiga: {
    Id: 9632,
    Name: 'Alhóndigas',
    Processes: {
      ManageAuction: {
        Id: 10886,
        Name: 'Gestión de subasta',
      },
    },
  },
}));
